var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mt-5"},[(_vm.error)?_c('div',[_c('p',[_vm._v(_vm._s(_vm.$t("Login failed. Please try again.")))]),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{ name: 'login' }}},[_vm._v(" "+_vm._s(_vm.$t("Back to Login"))+" ")])],1):_c('div',[_c('p',[_vm._v(_vm._s(_vm.$t("Signing in...")))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }